import {
  AfterViewInit,
  Component,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {Lang} from '../../../../../shared/interfaces/ad-reports';
import {Observable} from 'rxjs';
import {WidgetTotalsComponent} from '../widget-totals/widget-totals.component';
import {WidgetChartComponent} from "../widget-chart/widget-chart.component";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../../shared/store/store";
import {selectLanguageCode} from '../../../../../shared/store/languages/languages.selectors';
import {DashboardWidget} from '../../../../../shared/store/report/report-dashboard';
import {ComponentType} from '@angular/cdk/overlay';
import {ReportDashboardWidgetStore} from '../../../../../shared/store/report/report-dashboard-widget.store';
import {WidgetTextComponent} from '../widget-text/widget-text.component';
import {WidgetTableComponent} from '../widget-table/widget-table.component';
import {ReportDashboardStore} from '../../../../../shared/store/report/report-dashboard.store';
import { dialogOpen } from 'src/app/shared/store/dialog/dialog.actions';
import {ReportDashboardService} from '../../../../../shared/services/report-dashboard.service';
import {GridsterItem, GridsterItemComponentInterface} from 'angular-gridster2';
import {ReportStore} from '../../../../../shared/store/report/report.store';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  providers: [
    ReportDashboardWidgetStore
  ]
})
export class WidgetComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef }) public readonly componentContainer: ViewContainerRef;

  @Input() public widget: DashboardWidget;
  @Input() public dashboard: DashboardWidget[];

  public readonly lang$: Observable<Lang> = this._store.select(selectLanguageCode);
  public readonly loading$: Observable<boolean> = this._reportDashboardWidgetStore.loading$;

  public readonly componentType$: Observable<ComponentType<WidgetTextComponent | WidgetChartComponent | WidgetTableComponent | WidgetTotalsComponent>> = this._reportDashboardWidgetStore.componentType$;
  public readonly componentInjector$: Observable<Injector> = this._reportDashboardWidgetStore.componentInjector$;
  public readonly from$: Observable<string> = this._reportDashboardWidgetStore.from$;
  public readonly to$: Observable<string> = this._reportDashboardWidgetStore.to$;
  public readonly fromComparison$: Observable<string> = this._reportDashboardWidgetStore.toComparison$;
  public readonly toComparison$: Observable<string> = this._reportDashboardWidgetStore.fromComparison$;

  public readonly publicMode$: Observable<boolean> = this._reportStore.publicMode$;

  public enableTooltip: boolean = true;

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _reportStore: ReportStore,
    private readonly _reportDashboardStore: ReportDashboardStore,
    private readonly _reportDashboardWidgetStore: ReportDashboardWidgetStore,
    private readonly _reportDashboardService: ReportDashboardService
  ) {}

  ngOnInit(): void {
    if (this.widget.config.widget === WidgetTextComponent) {
      this.enableTooltip = false;
    }
  }

  ngAfterViewInit(): void {
    this._reportDashboardWidgetStore.init(
      this.widget
    );
  }

  ngOnDestroy(): void {}

  public onResize(event: { item: GridsterItem, itemComponent: GridsterItemComponentInterface }): void {
    this._reportDashboardWidgetStore.resize(event);
  }

  public onChange(event: { item: GridsterItem, itemComponent: GridsterItemComponentInterface }): void {
    this._reportDashboardStore.update();
  }

  public onSettings(): void {
    this._store.dispatch(dialogOpen({
      component: this._reportDashboardService.getConfigureComponent(this.widget),
      config: {
        width: '750px',
        height: 'auto'
      },
      data: {
        mode: 'modify',
        widget: this.widget,
        dashboard: this.dashboard
      }
    }));
  }

  public onDelete(): void {
    this._reportDashboardStore.deleteWidget(this.widget);
  }

}
